// Note: The first three badges will be featured on the podium

export const g2BadgeList = [
  'VideoHosting_MomentumLeader_Leader_Spring_2026',
  'VideoHosting_Leader_Leader_Spring_2026',
  'VideoHosting_BestRelationship_Mid-Market_Total_Spring_2026',
  'VideoHosting_BestResults_Mid-Market_Total_Spring_2026',
  'VideoHosting_MostImplementable_Mid-Market_Total_Spring_2026',
  'Best_Support_Spring_2026',
  'Best_Estimated_ROI_Spring_2026',
];
